import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets
import BurgerIcon from "../../assets/svg/BurgerIcon";
import logo from '../../assets/logo.png'

export default function TopNavbar({returnTo=false}) {
  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);


  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper className="flexCenter animate whiteBg" style={y > 100 ? { height: "60px" } : { height: "80px" }}>
        <NavInner className="container flexSpaceCenter">
          <Link className="pointer flexNullCenter" to="home" smooth={true}>
        <img src={logo} width='35%' height='35%' alt="CHAMAFLOW LOGO"/>
           
          </Link>
          <BurderWrapper className="pointer" onClick={() => toggleSidebar(!sidebarOpen)}>
            <BurgerIcon />
          </BurderWrapper>
          <UlWrapper className="flexNullCenter">
            <li className="semiBold font15 pointer">
             {
              returnTo ?
              <a href="/">Home</a>
            :
            <Link activeClass="active" style={{ padding: "10px 15px" }} to="home" spy={true} smooth={true} offset={-80}>
            Home
          </Link>
             }
            </li>

           
            <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a style={{ padding: "10px 15px" }} href="/#features" spy={true} smooth={true} offset={-80}>
                Features
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="features" spy={true} smooth={true} offset={-80}>
              Features
            </Link>
              }
              
            </li>

            
            <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a style={{ padding: "10px 15px" }} href="/#products" spy={true} smooth={true} offset={-80}>
                Products
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="products" spy={true} smooth={true} offset={-80}>
              Products
            </Link>
              }
              
            </li>
             <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a activeClass="active" style={{ padding: "10px 15px" }} href="/#pricing" spy={true} smooth={true} offset={-80}>
                Pricing
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="pricing" spy={true} smooth={true} offset={-80}>
              Pricing
            </Link>

              }
            
            </li>

            <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a activeClass="active" style={{ padding: "10px 15px" }} href="/#faqs" spy={true} smooth={true} offset={-80}>
                FAQs
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="faqs" spy={true} smooth={true} offset={-80}>
              FAQs
            </Link>

              }
             
            </li>
            
           
           {/* <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a activeClass="active" style={{ padding: "10px 15px" }} href="/#blog" spy={true} smooth={true} offset={-80}>
                Blog
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="blog" spy={true} smooth={true} offset={-80}>
              Blog
            </Link>

              }
           
            </li>*/}
            <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a activeClass="active" style={{ padding: "10px 15px" }} href="/#contact" spy={true} smooth={true} offset={-80}>
                Contact
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="contact" spy={true} smooth={true} offset={-80}>
              Contact
            </Link>

              }
             
            </li>
          </UlWrapper>
          <UlWrapperRight className="flexNullCenter">
          
            <li className="semiBold font15 pointer flexCenter">
              <Link to="/request-demo" target="_self" className="radius8 lightBg" style={{ padding: "10px 15px", backgroundColor: 'purple', color: '#fff', border: '2px solid purple' }}>
                Request Demo
              </Link>
            </li>
          </UlWrapperRight>
        </NavInner>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;
const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;
const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;


